import React from 'react';
import styles from './challengeBanner.module.scss';
import { ReactComponent as Swords } from '../../../assets/swords.svg';
import { Challenge, IChallengeService } from '../../../model/interfaces';
import { Link } from 'react-router-dom';
import { container } from 'tsyringe';
import { useAsyncData } from '@utils/hooks';
import { IPlayersOnlineRepository } from '@base/features/player/model/interfaces';

export default function ChallengeBanner() {
  const playersOnlineRepository: IPlayersOnlineRepository = container.resolve('playersOnlineRepository');
  const challengeService: IChallengeService = container.resolve('challengeService');
  const { data: challenges } = useAsyncData(async () =>
    (await challengeService.getAllChallenges()).filter(
      (challenge) => playersOnlineRepository.me?.pid === challenge.issuerId
    )
  );

  if (!(playersOnlineRepository.me && challenges?.length)) return null;

  return (
    <div className={styles.banner}>
      <Swords />
      <Message challenges={challenges} />
      <Swords />
    </div>
  );
}

function Message(props: { challenges: Challenge[] }) {
  return (
    <Link to="/ladder">
      <div className={styles.message}>
        <h2>{props.challenges.length === 1 ? 'challenge from' : 'you have'}</h2>
        <div>
          {props.challenges.length === 1
            ? props.challenges[0].issuerName
            : `${props.challenges.length} challenges`}
        </div>
      </div>
    </Link>
  );
}
